module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/filetypes/image icon-f2842a2d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/filetypes/image icon.svg
// module id = ./app/web/src/assets/filetypes/image icon.svg
// module chunks = 0